import { render, staticRenderFns } from "./UsageTermsForm.vue?vue&type=template&id=51d1072c&scoped=true"
import script from "./UsageTermsForm.vue?vue&type=script&lang=js"
export * from "./UsageTermsForm.vue?vue&type=script&lang=js"
import style0 from "./UsageTermsForm.vue?vue&type=style&index=0&id=51d1072c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1072c",
  null
  
)

export default component.exports